import React, { useRef, useState, useEffect } from 'react';
import styles from '../linksvibe/linksvibe.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado4 from '../../components/LinkPersonalizado4/linkPersonalizado4.tsx';

const Linksvibe: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.linksvibe}>

            <div className={styles["body-thunder"]} style={{ height: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mb-0">LINKS VIBE</h1>
                    <span className={styles["subtitle"]}>CARTÕES DIGITAIS</span>
                    <div className={styles.links}>
                        <LinkPersonalizado4
                            href="https://wa.me/5517991822859?text=Olá, gostaria de mais informações."
                            title="WHATSAPP"
                            colorText="#fff"
                            borderColor="#162947"
                        />
                        <LinkPersonalizado4
                            href="https://www.instagram.com/linksvibe_/?utm_source=ig_web_button_share_sheet"
                            title="INSTAGRAM"
                            colorText="#fff"
                            borderColor="#162947"
                        />
                        <LinkPersonalizado4
                            href="https://linksvibe.com.br/"
                            title="SITE"
                            colorText="#fff"
                            borderColor="#162947"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Linksvibe;
